import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=89a91728&scoped=true"
import script from "./GroupList.vue?vue&type=script&lang=js"
export * from "./GroupList.vue?vue&type=script&lang=js"
import style0 from "./GroupList.vue?vue&type=style&index=0&id=89a91728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a91728",
  null
  
)

export default component.exports